import Styles from "./index.module.scss";
import { ReactComponent as PensLogo } from '../../../../assets/logo/np-logo-rgb.svg';
import Partition from "../../elements/partition";
import { useAuthFrontLock } from '../../../../context/useAuthFrontContext';
import { LOCALE_MAPPING, FALLBACK_LOCALE } from "../../../../utils/constant/constant";

const Header = () => {
    const authFrontLock = useAuthFrontLock();

    const handleLogoClick = () => {
        const uiLocale = authFrontLock.getUILocales();
        const finalLocale = uiLocale && uiLocale.length > 0 ? uiLocale[0] : FALLBACK_LOCALE;
        const redirectUrl = `${process.env.REACT_APP_SITE_BASE_URL}/${LOCALE_MAPPING[finalLocale]}`;
        window.location.replace(redirectUrl);
    };

    return (
        <header className={Styles.header}>
            <div className={Styles.logo} onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
                <PensLogo />
            </div>
            <Partition breakPartition={false} />
        </header>
    );
};

export default Header;